import { useHistory } from "react-router-dom";

export namespace Route {
  export const use = (href: string) => {
    const history = useHistory();
    return { go: () => history.push(href) };
  };
}
